
import { mapActions } from 'vuex'
import types from '../store/types'

const renderEvent = {
    methods: {
        ...mapActions({
            updateRendered: types.appState.actions.updateRendered
        })
    },
    async beforeMount () {
        const rendered = false
        await this.updateRendered({ rendered })
    },
    mounted () {
        this.$nextTick(async () => {
            const rendered = true
            await this.updateRendered({ rendered })
        })
    }
}

export default {
    renderEvent
}

export {
    renderEvent
}
